// extracted by mini-css-extract-plugin
export default {"header":"QuestionPage_header__2BokF","main":"QuestionPage_main__bsBXs"};